import React from 'react';
import { Alert, Button, Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ShortDescripList from '../helpers/ShortDescripList';
import HelpPopover from './HelpPopover';
import _ from 'lodash';
import Dropzone from 'react-dropzone';

export default class ShortDescriptions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loading: false,
      errors: [],
      list: null,
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      errors: [],
      loading: false,
      list: null,
    });
  }

  onDrop = (files) => {
    this.setState({ list: files[0] });
  }

  toggleLoading = () => {
    this.setState({ loading: !this.state.loading });
  }

  hasErrors() {
    return this.state.errors.length > 0;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.loading && this.state.loading && this.state.list) {
      this.loadDescrips().then((updates) => {
        this.props.updateDescrips(updates);
        if (!this.hasErrors()) {
          this.toggle();
        }
        this.toggleLoading();
      });
    }
  }

  loadDescrips = () => {
    const loader = new ShortDescripList(this.state.list);
    return loader.indexedLines().then((lines) => {
      const updates = [];
      const errors = [];
      for (const name in lines) {
        const file = _.find(this.props.files, f => f.name === name);
        if (file) {
          updates.push(
            { id: file.id, attribute: 'short_desc', value: lines[name] },
          );
        } else {
          errors.push(`${name}\t${lines[name]}`);
        }
      }
      loader.errorLines().then(errs => this.setState({ errors: errors.concat(errs) }));
      return updates;
    });
  }

  errorList() {
    return (<Alert color="warning" className="uploader-alert">
      The following lines in your file were problematic. Short descriptions were not added for them.
      <ul>
        {this.state.errors.map(
          (err, index) => <li key={`err-${index}`}>{err}</li>,
        )}
      </ul>
    </Alert>);
  }

  render() {
    return (<div>
      Short Description&nbsp;&nbsp;
      <Button
        color="info"
        size="sm"
        onClick={this.toggle}
        title="short description info"
      >
        <i className="fa fa-info" />
      </Button>
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        key={'short-descrip-modal'}
        className="modal-info"
      >
        <div className="modal-header">
          <h3 className="modal-header-title">Short Descriptions for Images</h3>
        </div>
        <ModalBody>
          <p>
            The short description for an image will be added as alternative text
            to the image element in HTML and ePub outputs. This is not required,
            but it makes the image more accessible. Short descriptions cannot
            contain HTML control characters and must be 150 characters or fewer.
            There are two ways you can add short descriptions:
          </p>
          <ol>
            <li>
              Add a short description for each image using the appropriate field.
            </li>
            <li>
              Upload a text file below listing the short descriptions for each
              image. The file should have following format:
              <ul>
                <li>
                  One description per line.
                </li>
                <li>
                  Each line should have the image name, a tab, then the short description.
                </li>
              </ul>
            </li>
          </ol>
          {this.hasErrors() ? this.errorList() : null}
          <Container>
            <Row>
              <Col xs="6">
                <Dropzone
                  className="btn btn-secondary"
                  ref="dropzone"
                  multiple={false}
                  accept={'text/plain'}
                  onDrop={this.onDrop}
                >
                  <i className="fa fa-upload" />&nbsp;
                  Upload Description List.
                </Dropzone>
              </Col>
              <Col xs="6">
                {this.state.list ? this.state.list.name : ''}
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Container>
            <Row>
              <Col xs="6">
                <Button
                  color={this.state.loading ? 'secondary' : 'info'}
                  style={{ width: '150px' }}
                  onClick={this.toggleLoading}
                  className="float-md-start"
                  disabled={!this.state.list || this.state.loading || this.hasErrors()}
                >
                  {this.state.loading ?
                    <img src="/assets/loading.gif" style={{ height: '20px' }} /> :
                    'Load Description'}
                </Button>
              </Col>
              <Col xs="6">
                <Button
                  color="warning"
                  onClick={this.toggle}
                >
                  {this.hasErrors() ? 'Continue' : 'Cancel'}
                </Button>
              </Col>
            </Row>
          </Container>
        </ModalFooter>
      </Modal>
    </div>);
  }
}
